export const getS3URL = (userId: string, path: string) => {
    const url = `${import.meta.env.VITE_S3_URL}/${import.meta.env.VITE_S3_BUCKET_NAME}/${userId}/${path}`;
    return url;
};

//https://s3.ap-southeast-2.amazonaws.com/local.1template.com/
